import { useState } from "react";
import { useCentralApi, useCurrentUser } from "hooks/shared";

type AddExistingSignature = (ids: number[]) => Promise<any>;
type TaskAttachmentAddExistingResult = [
    AddExistingSignature,
    boolean
];

type UseTaskAttachmentAddExistingSignature = (taskId: number) => TaskAttachmentAddExistingResult;

const useTaskAttachmentAddExisting: UseTaskAttachmentAddExistingSignature = (taskId) => {
    const [ loading, setLoading ] = useState<boolean>(false); 

    const user = useCurrentUser();
    const fetcher = useCentralApi(user);   

    const addExisting = async (ids: number[]) => {
        if (user && user.id_token && taskId && ids.length > 0) {
            setLoading(true);
            try {
                const resp = await fetcher(`/api/v3/tasks/${taskId}/attachments/existing`, {
                    method: 'POST',
                    body: JSON.stringify(ids),
                });

                if (!resp.ok) {
                    // RESPOND TO ERRORS
                }

                const data = await resp.json() as any;

                return [
                    data.ids
                ];
            } catch (err) {
            } finally {
                setLoading(false);
            }
        }
    };

    return [
        addExisting,
        loading
    ];
};

export default useTaskAttachmentAddExisting;